import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { Box } from 'components/Layout'
import { DEVICE } from 'theme'
import { useToaster } from 'utils/useToaster'
import { useIsMinDevice } from 'utils/hooks/useMedia'
import { SignUpCard } from 'sharedComponents/SignUpCard'

interface RouteParams {
  token: string
}

const SignUp: React.VFC<RouteComponentProps<RouteParams>> = ({ match, history }) => {
  const isMobile = !useIsMinDevice(DEVICE.TABLET)
  const { setToastMessage } = useToaster()
  const { token } = match.params

  return (
    <Box
      minHeight="100vh"
      display="flex"
      justifyContent="center"
      alignItems={!isMobile ? 'center' : undefined}
    >
      <SignUpCard
        token={token}
        title="Sign up to ModMD"
        passwordLabel="Password"
        passwordPlaceholder="Enter your password"
        passwordConfirmationLabel="Password Confirmation"
        passwordConfirmationPlaceholder="Enter your password again"
        signUpButtonLabel="Sign up"
        alreadyHaveAccountLabel="Already have account?"
        signInButtonLabel="Sign in"
        onSignInButtonOnClick={() => history.push('/')}
        onSignUpSuccess={() => {
          setToastMessage('Successfully signed up!', 'success')
          history.push('/')
        }}
      />
    </Box>
  )
}

export default SignUp
